import * as stylex from '@stylexjs/stylex'
import { type ElementType } from 'react'
import { Box, type BoxProps } from '../Box/Box'
import { container } from '../tokens/container.stylex'

const style = stylex.create({
  root: {
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: container.maxWidth,
    width: '100%',
  },
})

/** Container 的 props，繼承 Box 的所有 ExtendStyleProps。 */
export type ContainerProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * Container 是居中的版面容器，自動套用最大寬度限制（maxWidth）。
 * 繼承 Box 的所有 ExtendStyleProps。
 */
export const Container = <RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(
  props: ContainerProps<RootComponent, BoxElement>,
) => {
  const { component = 'div', rootStyle, ...rest } = props
  return (
    <Box component={component} rootStyle={[style.root, rootStyle]} {...rest} />
  )
}
